export default "__VITE_ASSET__MXUVbvxC__"